"use strict";
import { Interface } from "@ethersproject/abi";
import { validateAndParseAddress } from "@uniswap/sdk-core";
import IPeripheryPaymentsWithFeeExtended from "@uniswap/swap-router-contracts/artifacts/contracts/interfaces/IPeripheryPaymentsWithFeeExtended.sol/IPeripheryPaymentsWithFeeExtended.json";
import { Payments, toHex } from "@uniswap/v3-sdk";
function encodeFeeBips(fee) {
  return toHex(fee.multiply(1e4).quotient);
}
export class PaymentsExtended {
  static {
    this.INTERFACE = new Interface(IPeripheryPaymentsWithFeeExtended.abi);
  }
  /**
   * Cannot be constructed.
   */
  constructor() {
  }
  static encodeUnwrapWETH9(amountMinimum, recipient, feeOptions) {
    if (typeof recipient === "string") {
      return Payments.encodeUnwrapWETH9(amountMinimum, recipient, feeOptions);
    }
    if (feeOptions) {
      const feeBips = encodeFeeBips(feeOptions.fee);
      const feeRecipient = validateAndParseAddress(feeOptions.recipient);
      return PaymentsExtended.INTERFACE.encodeFunctionData("unwrapWETH9WithFee(uint256,uint256,address)", [
        toHex(amountMinimum),
        feeBips,
        feeRecipient
      ]);
    } else {
      return PaymentsExtended.INTERFACE.encodeFunctionData("unwrapWETH9(uint256)", [toHex(amountMinimum)]);
    }
  }
  static encodeSweepToken(token, amountMinimum, recipient, feeOptions) {
    if (typeof recipient === "string") {
      return Payments.encodeSweepToken(token, amountMinimum, recipient, feeOptions);
    }
    if (feeOptions) {
      const feeBips = encodeFeeBips(feeOptions.fee);
      const feeRecipient = validateAndParseAddress(feeOptions.recipient);
      return PaymentsExtended.INTERFACE.encodeFunctionData("sweepTokenWithFee(address,uint256,uint256,address)", [
        token.address,
        toHex(amountMinimum),
        feeBips,
        feeRecipient
      ]);
    } else {
      return PaymentsExtended.INTERFACE.encodeFunctionData("sweepToken(address,uint256)", [
        token.address,
        toHex(amountMinimum)
      ]);
    }
  }
  static encodePull(token, amount) {
    return PaymentsExtended.INTERFACE.encodeFunctionData("pull", [token.address, toHex(amount)]);
  }
  static encodeWrapETH(amount) {
    return PaymentsExtended.INTERFACE.encodeFunctionData("wrapETH", [toHex(amount)]);
  }
}
